export enum FeatureFlags {
  BasicSearch = "basicSearch",
  CharacteristicsSearch = "characteristicsSearch",
  DurationSearch = "durationSearch",
  FactSheetPlantGuide = "factsheetGuidesSearch",
  GrowthHabitSearch = "growthHabitSearch",
  GroupSearch = "groupSearch",
  ImageSearch = "imageSearch",
  NoxiousInvasiveSearch = "invasiveNoxiousSearch",
  RaritySearch = "raritySearch",
  StateSearch = "stateSearch",
  WetlandSearch = "wetlandSearch"
}

export enum SearchType {
  CharacteristicsSearch = "CharacteristicsSearch",
  BasicSearch = "BasicSearch",
  DurationSearch = "DurationSearch",
  FactSheetPlantGuideSearch = "FactSheetPlantGuideSearch",
  GrowthHabitSearch = "GrowthHabitSearch",
  GroupSearch = "GroupSearch",
  ImageSearch = "ImageSearch",
  NoxiousInvasiveSearch = "NoxiousInvasiveSearch",
  RaritySearch = "RaritySearch",
  StateSearch = "StateSearch",
  WetlandSearch = "WetlandSearch"
}

export enum SearchResultType {
  Characteristics = "Characteristics",
  Basic = "Basic",
  Duration = "Duration",
  FactSheetPlantGuide = "Documents",
  Group = "Group",
  GrowthHabit = "Growth Habit",
  Image = "Images",
  Invasive = "Invasive",
  Noxious = "Noxious",
  Rarity = "Rarity",
  State = "State",
  Wetland = "Wetland"
}
